import Custom500Page from 'components/500';

const Custom500 = () => <Custom500Page />;

export default Custom500;
